import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "_shared/_stores/redux-store";
import Guid from "_shared/guids/guid";
import { feeScheduleApi } from "marketplace/teams/fee-schedules/_api/fee-schedule-api";
import { FeeScheduleJSON } from "marketplace/teams/fee-schedules/_schemas/fee-schedule-schema";
import MarketplaceTeam from "marketplace/teams/team";

export type FeeScheduleStoreState = Record<string, FeeScheduleJSON[]>;

const initialState: FeeScheduleStoreState = {};

export const feeSchedulesSlice = createSlice({
  name: "feeSchedules",
  initialState,
  reducers: {
    addFeeSchedule: (
      state,
      action: PayloadAction<{ team: MarketplaceTeam; feeSchedule: FeeScheduleJSON }>
    ) => {
      if (!action.payload.team.id) {
        return;
      }
      const teamIdValue = action.payload.team.id.value;
      if (!state[teamIdValue]) {
        state[teamIdValue] = [];
      }
      state[teamIdValue].push(action.payload.feeSchedule);
    },
    removeFeeSchedule: (
      state,
      action: PayloadAction<{ team: MarketplaceTeam; feeSchedule: FeeScheduleJSON }>
    ) => {
      if (!action.payload.team.id) {
        return;
      }
      const teamIdValue = action.payload.team.id.value;
      if (state[teamIdValue]) {
        state[teamIdValue] = state[teamIdValue].filter(
          (feeSchedule) => feeSchedule.id !== action.payload.feeSchedule.id
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(feeScheduleApi.endpoints.getFeeSchedulesForTeam.matchFulfilled, (state, action) => {
      const teamId = action.meta.arg.originalArgs.teamId;
      state[teamId] = action.payload;
    });
  },
});

export const { addFeeSchedule, removeFeeSchedule } = feeSchedulesSlice.actions;

export const getFeeSchedulesForTeam = (teamId: Guid) => (state: RootState) =>
  (state.feeSchedules as FeeScheduleStoreState)[teamId.value];
